import React, { Component } from 'react';
import './sidemenu-loader.css';


class SideMenuLoader extends Component {

    render() {

        return (
            <div class="cate_sidemenu">
                <h5 class="hidden-xs">CATEGORIES</h5>
                <div class="panel-group" id="accordion">
                         <div class="demo "></div>
                </div>

            </div>

        );


    }


}


export default SideMenuLoader;


// WEBPACK FOOTER //
// ./src/industry-reports/content/sidemenu/sidemenu-loader.js